<div class="report-dialog">
  <h2 mat-dialog-title>
    <mat-icon>description</mat-icon>
    {{isPlanned ? 'Wartungs-Report' : 'Einsatz-Report'}}
  </h2>

  <mat-dialog-content>
    <!-- Summary -->
    <div class="report-section">
      <h3>Auftragsinformationen</h3>
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Kunde</span>
          <span class="value">{{customer?.name ?? '–'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Adresse</span>
          <span class="value">{{customer?.address ?? '–'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Auftrag</span>
          <span class="value">{{maintenance.title}}</span>
        </div>
        <div class="info-item">
          <span class="label">Anlage</span>
          <span class="value">{{maintenance.equipment?.name ?? '–'}}</span>
        </div>
        <div class="info-item">
          <span class="label">Datum</span>
          <span class="value">{{maintenance.scheduledDate | date:'dd.MM.yyyy'}}</span>
        </div>
        <div class="info-item" *ngIf="!isPlanned">
          <span class="label">Arbeitszeit</span>
          <span class="value">{{durationText}}</span>
        </div>
        <div class="info-item" *ngIf="!isPlanned">
          <span class="label">Fahrzeit</span>
          <span class="value">{{travelTimeText}}</span>
        </div>
        <div class="info-item" *ngIf="!isPlanned && regieLines.length > 0">
          <span class="label">Regie</span>
          <span class="value">{{regieText}}</span>
        </div>
        <div class="info-item" *ngIf="arrivalTime">
          <span class="label">Ankunft</span>
          <span class="value">{{arrivalTime}}</span>
        </div>
        <div class="info-item" *ngIf="departureTime">
          <span class="label">Abreise</span>
          <span class="value">{{departureTime}}</span>
        </div>
      </div>
    </div>

    <!-- Work Description (Service Calls) -->
    <div class="report-section" *ngIf="!isPlanned && (description || workItems.length > 0)">
      <h3>Durchgeführte Arbeiten</h3>
      <p class="sc-description" *ngIf="description">{{description}}</p>
      <div class="work-items-list" *ngIf="workItems.length > 0">
        <div class="work-item-row" *ngFor="let item of workItems; let i = index">
          <span class="wi-num">{{i + 1}}.</span>
          <span class="wi-text">{{item}}</span>
        </div>
      </div>
    </div>

    <!-- Checklists Summary -->
    <div class="report-section" *ngIf="checklists.length > 0">
      <h3>Checklisten ({{completedItems}}/{{totalItems}} erledigt)</h3>
      <div class="checklist-summary" *ngFor="let cl of checklists">
        <strong>{{cl.name || 'Checkliste'}}</strong>
        <div class="summary-items">
          <div *ngFor="let item of cl.items" class="summary-item" [class.done]="item.isChecked">
            <mat-icon>{{item.isChecked ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
            {{item.description}}
          </div>
        </div>
      </div>
    </div>

    <!-- Regiestunden -->
    <div class="report-section" *ngIf="!isPlanned && regieLines.length > 0">
      <h3>Regiestunden</h3>
      <div class="material-summary">
        <div *ngFor="let line of regieLines" class="mat-row">
          <span>{{line.label}} · {{line.hours | number:'1.2-2'}} h x {{line.hourlyRate | number:'1.2-2'}} €/h</span>
          <span class="mat-qty">{{line.hours * line.hourlyRate | currency:'EUR':'symbol':'1.2-2'}}</span>
        </div>
        <div class="mat-row">
          <strong>Gesamt</strong>
          <strong class="mat-qty">{{getRegieTotal() | currency:'EUR':'symbol':'1.2-2'}}</strong>
        </div>
      </div>
    </div>

    <!-- Materials -->
    <div class="report-section" *ngIf="materials.length > 0">
      <h3>Verwendetes Material</h3>
      <div class="material-summary">
        <div *ngFor="let mat of materials" class="mat-row">
          <span>{{mat.name}}</span>
          <span class="mat-qty">{{mat.quantity}} {{mat.unit}}</span>
        </div>
      </div>
    </div>

    <!-- Photos (Service Calls) -->
    <div class="report-section" *ngIf="scPhotos.length > 0">
      <h3>Fotodokumentation ({{scPhotos.length}})</h3>
      <div class="photo-grid">
        <div class="photo-thumb" *ngFor="let photo of scPhotos">
          <img [src]="photo.dataUrl" [alt]="photo.name">
        </div>
      </div>
    </div>

    <!-- Existing Customer Signature (Service Calls) -->
    <div class="report-section" *ngIf="existingSignatureDataUrl">
      <h3>Vorhandene Kundenunterschrift</h3>
      <div class="existing-sig-block">
        <span class="sig-name" *ngIf="existingCustomerSigneeName">{{existingCustomerSigneeName}}</span>
        <img [src]="existingSignatureDataUrl" alt="Unterschrift" class="existing-sig-image">
      </div>
    </div>

    <!-- Additional Notes -->
    <div class="report-section">
      <h3>Zusätzliche Anmerkungen</h3>
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput [(ngModel)]="additionalNotes" rows="3"
                  placeholder="Weitere Anmerkungen zum Report..."></textarea>
      </mat-form-field>
    </div>

    <!-- Signatures -->
    <div class="report-section signatures-section">
      <h3>Unterschriften</h3>

      <!-- Technician Signature -->
      <div class="signature-block">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name Techniker</mat-label>
          <input matInput [(ngModel)]="technicianName">
        </mat-form-field>
        <div class="signature-canvas-wrapper">
          <canvas #technicianCanvas class="signature-canvas"></canvas>
          <button mat-icon-button class="clear-sig" (click)="clearSignature('tech')" matTooltip="Unterschrift löschen">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <span class="sig-label">Unterschrift Techniker</span>
      </div>

      <!-- Customer Signature Toggle -->
      <div class="signature-toggle">
        <mat-slide-toggle [(ngModel)]="includeCustomerSignature" color="primary">
          Kundenunterschrift im PDF
        </mat-slide-toggle>
      </div>

      <!-- Customer Signature -->
      <div class="signature-block" *ngIf="includeCustomerSignature">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name Kunde</mat-label>
          <input matInput [(ngModel)]="customerSigneeName">
        </mat-form-field>
        <div class="signature-canvas-wrapper">
          <canvas #customerCanvas class="signature-canvas"></canvas>
          <button mat-icon-button class="clear-sig" (click)="clearSignature('cust')" matTooltip="Unterschrift löschen">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <span class="sig-label">Unterschrift Kunde</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Schließen</button>
    <button mat-raised-button color="primary" (click)="generatePDF()" [disabled]="savingToServer">
      <mat-icon *ngIf="!savingToServer">picture_as_pdf</mat-icon>
      <mat-spinner *ngIf="savingToServer" diameter="18" class="btn-spinner"></mat-spinner>
      {{savingToServer ? 'Wird gespeichert...' : 'PDF erstellen'}}
    </button>
  </mat-dialog-actions>
</div>
